import { Dropdown, DropdownProps } from 'primereact/dropdown';

export const DropdownWithFilterAutofocus = (props: DropdownProps) => {
    return (
        <Dropdown
            filterInputAutoFocus={true}
            {...props}
        />
    );
};
